// TODO: jake jsou byt dalsi hodnoty?

export enum GroupCode {
    Custom = "CUSTOM",
    SetHandicap = "SET_HANDICAP",
    MatchResult = "MATCH_RESULT",
    DoubleChance = "DOUBLE_CHANCE",
    GameHandicap = "GAME_HANDICAP",
    MatchWinner = "MATCH_WINNER",
    SetWinnerNthSet = "SET_WINNER_NTH_SET",
    TotalGamesOverUnder = "TOTAL_GAMES_OVER/UNDER",
    MatchResultNoOvertime = "MATCH_RESULT_NO_OVERTIME",
}
